// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Кнопки с занятостью
 */
.occupation_editorPanel__BO3L9 {
    position: fixed;
    left: 50%;
    bottom: max(8px, env(safe-area-inset-bottom));
    z-index: 100;
    width: min(calc(100vw - 16px), 560px);
    padding: 6px;
    transform: translateX(-50%);
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 12px;
    background-color: #ecd2b5;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3);
}

.occupation_buttonContainer__69jsy {
    font-family: 'Roboto', sans-serif;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(42px, 1fr);
    gap: 4px;
    width: 100%;
    box-sizing: border-box;
}

.occupation_buttonContainer__69jsy button {
    border: 1px solid rgba(0, 0, 0, 0.65);
    min-width: 42px;
    min-height: 46px;
    padding: 0 8px;
    border-radius: 7px;
    font-weight: bold;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
}

.occupation_occupationButton__hIa4Q {
    transition: transform 120ms ease, box-shadow 120ms ease;
}

.occupation_selectedButton__l73Ah {
    outline: 3px solid #168acd;
    outline-offset: -3px;
    box-shadow: 0 0 0 2px #fff;
    transform: translateY(-2px);
}

.occupation_additionalButtons__pAPXO {
    display: contents;
}

.occupation_cancelButton__3s7Xs,
.occupation_saveButton__uv4Kv {
    background-color: #f3f3f3;
}

@media (hover: hover) {
    .occupation_buttonContainer__69jsy button:hover {
        filter: brightness(0.92);
    }
}

@media (max-width: 380px) {
    .occupation_editorPanel__BO3L9 {
        width: calc(100vw - 8px);
        padding: 4px;
    }

    .occupation_buttonContainer__69jsy {
        gap: 3px;
    }

    .occupation_buttonContainer__69jsy button {
        min-width: 38px;
        min-height: 44px;
        padding: 0 4px;
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/occupation-buttons/occupation.module.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;IACI,eAAe;IACf,SAAS;IACT,6CAA6C;IAC7C,YAAY;IACZ,qCAAqC;IACrC,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,oCAAoC;IACpC,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,QAAQ;IACR,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,YAAY;IAChB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":["/**\n * Кнопки с занятостью\n */\n.editorPanel {\n    position: fixed;\n    left: 50%;\n    bottom: max(8px, env(safe-area-inset-bottom));\n    z-index: 100;\n    width: min(calc(100vw - 16px), 560px);\n    padding: 6px;\n    transform: translateX(-50%);\n    box-sizing: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    border-radius: 12px;\n    background-color: #ecd2b5;\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3);\n}\n\n.buttonContainer {\n    font-family: 'Roboto', sans-serif;\n    display: grid;\n    grid-auto-flow: column;\n    grid-auto-columns: minmax(42px, 1fr);\n    gap: 4px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.buttonContainer button {\n    border: 1px solid rgba(0, 0, 0, 0.65);\n    min-width: 42px;\n    min-height: 46px;\n    padding: 0 8px;\n    border-radius: 7px;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    touch-action: manipulation;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.occupationButton {\n    transition: transform 120ms ease, box-shadow 120ms ease;\n}\n\n.selectedButton {\n    outline: 3px solid #168acd;\n    outline-offset: -3px;\n    box-shadow: 0 0 0 2px #fff;\n    transform: translateY(-2px);\n}\n\n.additionalButtons {\n    display: contents;\n}\n\n.cancelButton,\n.saveButton {\n    background-color: #f3f3f3;\n}\n\n@media (hover: hover) {\n    .buttonContainer button:hover {\n        filter: brightness(0.92);\n    }\n}\n\n@media (max-width: 380px) {\n    .editorPanel {\n        width: calc(100vw - 8px);\n        padding: 4px;\n    }\n\n    .buttonContainer {\n        gap: 3px;\n    }\n\n    .buttonContainer button {\n        min-width: 38px;\n        min-height: 44px;\n        padding: 0 4px;\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorPanel": `occupation_editorPanel__BO3L9`,
	"buttonContainer": `occupation_buttonContainer__69jsy`,
	"occupationButton": `occupation_occupationButton__hIa4Q`,
	"selectedButton": `occupation_selectedButton__l73Ah`,
	"additionalButtons": `occupation_additionalButtons__pAPXO`,
	"cancelButton": `occupation_cancelButton__3s7Xs`,
	"saveButton": `occupation_saveButton__uv4Kv`
};
export default ___CSS_LOADER_EXPORT___;
